// frontend/src/services/inventoryService.js
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_NETLIFY_API_URL || process.env.REACT_APP_API_URL //ENV VARIABLE WITH THE DEFAULT URL 
const tkn = sessionStorage.getItem("urtkn")
const location = localStorage.getItem('usrlctn')

const updateInventoryCount = async ({ id, invOnHand }) => {
    console.log(id, invOnHand)
    const response = await axios.put(`${baseUrl}/api/product-inventory-update/${id}`, { invOnHand },
        {
            headers: { Authorization: `Bearer ${tkn}` },
            params: { location }
        },

    );
    return response.data;
};

export const useUpdateInventoryCount = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateInventoryCount,
        onSuccess: () => {
            // Invalidate and refetch specific queries after a successful update
            queryClient.invalidateQueries(['inventoryData']); // Adjust query key as needed
        },
        onError: (error) => {
            console.error('Error updating inventory:', error);
            // You can add more sophisticated error handling here, e.g., toast notifications
        },
    });
};